// src/components/FAQ.js
import React from 'react';

const FAQ = () => {
    return (
        <div>
            <h2>FAQ</h2>
            {/* Content for FAQ */}
            <p>No frequently asked questions. Please come back later.</p>
        </div>
    );
};

export default FAQ;
